import { render, staticRenderFns } from "./SundryCreditorView.vue?vue&type=template&id=00d5a12c"
import script from "./SundryCreditorView.vue?vue&type=script&lang=js"
export * from "./SundryCreditorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d5a12c')) {
      api.createRecord('00d5a12c', component.options)
    } else {
      api.reload('00d5a12c', component.options)
    }
    module.hot.accept("./SundryCreditorView.vue?vue&type=template&id=00d5a12c", function () {
      api.rerender('00d5a12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorView.vue"
export default component.exports